import React from 'react'
import { Views } from '../../views'

const Support = () => {
    const { Support } = Views
    return (
        <Support />
    )
}

export default Support